import { getContext, setContext } from "svelte";
import { derived, writable } from "svelte/store";
const CANNON = {};
export function setCannonContext(context) {
    setContext(CANNON, context);
}
export function getCannonContext() {
    const context = getContext(CANNON);
    if (!context) {
        throw new Error("Missing context, not nested inside <World>");
    }
    return context;
}
export function derivedBodies(idToBody, targets) {
    return derived(idToBody, ($idToBody) => {
        console.warn("deprecated in favor of bodiesFor");
        const bodies = [];
        for (const target of targets) {
            const body = $idToBody[target];
            if (!body) {
                return false;
            }
            bodies.push(body);
        }
        return bodies;
    });
}
export function bodiesFor(targets) {
    const input = writable(targets);
    let previous = targets.join("\n");
    const changedInput = derived(input, ($input, set) => {
        const next = $input.join("\n");
        if (previous !== next) {
            set($input);
            previous = next;
        }
    }, targets);
    const { idToBody } = getCannonContext();
    const store = derived([changedInput, idToBody], ([$changedInput, $idToBody]) => {
        const bodies = [];
        for (const target of $changedInput) {
            const body = $idToBody[target];
            if (!body) {
                return false;
            }
            bodies.push(body);
        }
        return bodies;
    });
    return {
        subscribe: store.subscribe,
        for: input.set,
    };
}
